var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1371_63731)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5735 12.8457C20.2999 12.8466 19.2691 13.8802 19.27 15.1538C19.2691 16.4275 20.3008 17.461 21.5744 17.462H23.8788V15.1548C23.8797 13.8812 22.848 12.8476 21.5735 12.8457C21.5744 12.8457 21.5744 12.8457 21.5735 12.8457ZM21.5735 19.002H15.4304C14.1567 19.0029 13.125 20.0365 13.126 21.3101C13.1241 22.5838 14.1558 23.6173 15.4294 23.6192H21.5735C22.8471 23.6183 23.8788 22.5847 23.8779 21.3111C23.8788 20.0365 22.8471 19.0029 21.5735 19.002Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1659 21.3101C36.1669 20.0365 35.1352 19.0029 33.8616 19.002C32.5879 19.0029 31.5562 20.0365 31.5572 21.3101V23.6192H33.8616C35.1352 23.6183 36.1669 22.5847 36.1659 21.3101ZM30.0219 21.3101V15.1538C30.0228 13.8812 28.9921 12.8476 27.7184 12.8457C26.4448 12.8466 25.4131 13.8802 25.4141 15.1538V21.3101C25.4122 22.5838 26.4439 23.6173 27.7175 23.6192C28.9911 23.6183 30.0228 22.5847 30.0219 21.3101Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7175 35.9327C28.9911 35.9317 30.0228 34.8981 30.0218 33.6245C30.0228 32.3509 28.9911 31.3173 27.7175 31.3164H25.4131V33.6245C25.4121 34.8972 26.4438 35.9308 27.7175 35.9327ZM27.7175 29.7754H33.8615C35.1351 29.7745 36.1668 28.7409 36.1659 27.4673C36.1678 26.1937 35.1361 25.1601 33.8625 25.1582H27.7184C26.4448 25.1591 25.4131 26.1927 25.414 27.4663C25.4131 28.7409 26.4438 29.7745 27.7175 29.7754Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.126 27.4663C13.125 28.74 14.1567 29.7735 15.4304 29.7745C16.704 29.7735 17.7357 28.74 17.7347 27.4663V25.1582H15.4304C14.1567 25.1591 13.125 26.1927 13.126 27.4663ZM19.27 27.4663V33.6226C19.2682 34.8963 20.2999 35.9298 21.5735 35.9317C22.8471 35.9308 23.8788 34.8972 23.8778 33.6236V27.4682C23.8797 26.1946 22.848 25.161 21.5744 25.1591C20.2999 25.1591 19.2691 26.1927 19.27 27.4663Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_63731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.3945 12.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.661bc371e3c7cfdda3f65b66f22e57ef.svg";
export { ForwardRef as ReactComponent };